import { useState } from "react";
import { Chart, registerables } from "chart.js";
// Components
import {
  GraphicContainer,
  GraphicRotateDiv,
  RangeDatesDiv,
  HeaderDiv,
  MaximizeGraphicButton,
  MaximizeGraphicImg,
  GraphicTitle,
  ReactTooltipStyled,
  InfoButton,
  InfoImg,
  BetaTitle,
  AxisAndGraphicDiv,
  AxisYSizeDiv,
  AxisY,
  GraphicSizeDiv,
  AxisX,
} from "./styles";
// Assets
import IcoInfoImg from "../../../assets/icons/ico_info.svg";
import MaximizeImg from "../../../assets/icons/ico_maximize_graphic.svg";
import MinimizeImg from "../../../assets/icons/ico_minimize_graphic.svg";

const Graphic = ({
  children,
  Title,
  Type,
  data,
  axisY,
  axisX,
  max = false,
  graphicDescription = "There is no description",
  isBeta = false,
  height = "200px",
  paramScales = false,
}) => {
  Chart.register(...registerables);
  const [maximizeActive, setMaximizeActive] = useState(false);
  const handleSetMaximizeActive = () => setMaximizeActive(!maximizeActive);

  const renderScales = () => {
    const defaultScales = {
      y: {
        beginAtZero: true,
      },
      x: {
        beginAtZero: true,
      },
    };
    let scales = paramScales ? paramScales : defaultScales;
    if (max) scales.y.max = max;
    return scales;
  };

  const renderChart = () => {
    return (
      <Type
        data={data}
        options={{
          clip: false,
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                filter: (legendItem, chartData) => {
                  let entries = chartData.datasets.map((e) => e.label);
                  return entries.indexOf(legendItem.text) === legendItem.datasetIndex;
                },
              },
            },
          },
          scales: renderScales(),
        }}
      />
    );
  };

  return (
    <GraphicContainer maximizeGraphic={maximizeActive}>
      <GraphicRotateDiv maximizeGraphic={maximizeActive}>
        <RangeDatesDiv>{children}</RangeDatesDiv>
        <HeaderDiv>
          <GraphicTitle>{Title}</GraphicTitle>
          <InfoButton data-for="graphicInfoButton" data-tip={graphicDescription}>
            <InfoImg src={IcoInfoImg} alt="ico-info" />
          </InfoButton>
          <ReactTooltipStyled id="graphicInfoButton" place="top" type="dark" effect="solid" delayShow={100} delayHide={100} />
          {isBeta && <BetaTitle>Beta</BetaTitle>}
        </HeaderDiv>
        <MaximizeGraphicButton onClick={handleSetMaximizeActive}>
          <MaximizeGraphicImg src={maximizeActive ? MinimizeImg : MaximizeImg} alt="btn-max-min-graphic" maximizeGraphic={maximizeActive} />
        </MaximizeGraphicButton>
        <AxisAndGraphicDiv height={height}>
          <AxisYSizeDiv>
            <AxisY>{axisY}</AxisY>
          </AxisYSizeDiv>
          <GraphicSizeDiv>{renderChart()}</GraphicSizeDiv>
        </AxisAndGraphicDiv>
        <AxisX>{axisX}</AxisX>
      </GraphicRotateDiv>
    </GraphicContainer>
  );
};

export default Graphic;
